// extracted by mini-css-extract-plugin
export default {"base":"ActionRemoveMod_base__3TUtn","isDisabled":"ActionRemoveMod_isDisabled__dQnX1"};